import { all, fork, put, takeEvery, takeLatest, call, select, delay } from "redux-saga/effects"
import * as actionTypes from "appRedux/actions/nightAudit/rateApproveType"
import * as actionCreators from "appRedux/actions/nightAudit/rateApprove"

import {
  rateApproveDataSourceUpdate,
  rateApproveProcessSuccess,
  rateApproveProcessReset
} from "appRedux/actions/nightAudit/rateApprove"
import { userSignOut } from "appRedux/actions/Auth"

import { APIGetRequest, APIPostRequest } from "util/connection"
import { API_URL_V1, API_PMS_HEADERS } from "constants/ApiSetting"
import { getItems } from "util/localStorage"
import dayjs from 'dayjs'
import { ApiResponse } from "constants/ActionTypes"
import { RateApproveType } from "appRedux/reducers/nightAudit/rateApprove"

function* rateApprovePreviewProcess() {

  const { access_token } = yield call(getItems, ['access_token'])
  const AccessToken = access_token
  const url = `${API_URL_V1}pms/nightAudit/rateApproval/`
  API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`

  try {
    const response: ApiResponse = yield APIGetRequest(url, API_PMS_HEADERS)
    if (response.status === 200) {

      const rateApproveInfo = response.data.map((obj: RateApproveType) => {
        const container = {} as RateApproveType
        container.register_id = obj.register_id
        container.booking_id = obj.booking_id
        container.booking_item = obj.booking_item
        container.approved = obj.approved
        container.approve_user = obj.approve_user
        container.approve_time = obj.approve_time
        container.roomtype_id = obj.roomtype_id
        container.roomtype_code = obj.roomtype_code
        container.room_number = obj.room_number
        container.room_type = obj.room_type
        container.arrival = obj.arrival
        container.departure = obj.departure
        container.checkin_time = obj.checkin_time
        container.checkin_user = obj.checkin_user
        container.guest_name = obj.guest_name
        container.group_name = obj.group_name
        container.channel_name = obj.channel_name || ""
        container.actual_rate_plan = obj.actual_rate_plan || ""
        container.actual_rate_total = obj.actual_rate_total
        container.booking_rate_plan = obj.booking_rate_plan
        container.booking_rate_total = obj.booking_rate_total
        container.rate_diff = obj.rate_diff
        container.upgrade_type = obj.upgrade_type

        return container
      })

      /* if no error put everything to reducer */
      yield put(actionCreators.rateApproveDataSourceUpdate(rateApproveInfo))
      yield delay(100)

    } else {
      /* Show error message and signout */
      const { message, data } = response.data
      const processStatus = { status: false, action: "preview", message }
      yield put(actionCreators.rateApproveProcessSuccess(processStatus))
      yield delay(100)
      yield put(actionCreators.rateApproveProcessReset())
      yield delay(100)
      if (response.status === 403) {
        /* if data is not null force signout */
        if (data)
          yield put(userSignOut())
      }

    }
  } catch (error) {
    const processStatus = { status: false, action: "preview", message: error }
    yield put(actionCreators.rateApproveProcessSuccess(processStatus))
    yield put(actionCreators.rateApproveProcessReset())
  }

}

function* rateApproveUpdateProcess({ payload }: actionTypes.RateApproveUpdate) {
  const [{ register_id, approved }] = payload

  const approve_time = dayjs().format()
  const { rateApprove: { dataSource }, auth: { authUser } } = yield select(state => state)
  const { user_name: approve_user } = authUser

  let rateApproveInfo = {} as any
  rateApproveInfo.approve_data = payload
  try {
    const { access_token } = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/nightAudit/approveRates/`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
    const API_DATABODY = rateApproveInfo
    const response: ApiResponse = yield APIPostRequest(url, API_DATABODY, API_PMS_HEADERS)

    if (response.status === 200) {
      const rateApproveTemp = dataSource.map((o: any) => {
        if (o.register_id === register_id)
          if (approved)
            return { ...o, approved, approve_time, approve_user }
          else
            return { ...o, approved, approve_time: null, approve_user: null }
        else
          return o
      })
      yield put(actionCreators.rateApproveDataSourceUpdate(rateApproveTemp))
      yield delay(100)
    } else {
      const { message, data } = response.data
      const processStatus = { status: false, action: "update", message }
      yield put(actionCreators.rateApproveProcessSuccess(processStatus))
      yield put(actionCreators.rateApproveProcessReset())
      if (response.status === 403) {
        /* if data is not null force signout */
        if (data)
          yield put(userSignOut())
      }
    }

  } catch (error) {
    const processStatus = { status: false, action: "update", message: error }
    yield put(rateApproveProcessSuccess(processStatus))
    yield delay(100)
    yield put(rateApproveProcessReset())
    yield delay(100)
  }
}

function* rateApproveUpdateAllProcess({ payload }: actionTypes.RateApproveUpdateAll) {

  let rateApproveInfo = {} as any
  rateApproveInfo.approve_data = payload
  try {
    const { access_token } = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/nightAudit/approveRates/`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
    const API_DATABODY = rateApproveInfo
    const response: ApiResponse = yield APIPostRequest(url, API_DATABODY, API_PMS_HEADERS)

    if (response.status === 200) {
      yield call(rateApprovePreviewProcess)
    } else {
      const { message, data } = response.data
      const processStatus = { status: false, action: "update", message }
      yield put(actionCreators.rateApproveProcessSuccess(processStatus))
      yield put(actionCreators.rateApproveProcessReset())
      if (response.status === 403) {
        /* if data is not null force signout */
        if (data)
          yield put(userSignOut())
      }
    }

  } catch (error) {
    const processStatus = { status: false, action: "update", message: error }
    yield put(actionCreators.rateApproveProcessSuccess(processStatus))
    yield put(actionCreators.rateApproveProcessReset())
  }
}

function* rateApproveViewSummaryProcess({ payload }: actionTypes.RateApproveViewSummary) {
  const { summaryType, id } = payload

  const url = summaryType === "booking" ?
    `${API_URL_V1}pms/reservation/bookingItem/${id}/summary/` :
    `${API_URL_V1}pms/registration/guestInHouse/${id}/summary/`
  const { access_token } = yield call(getItems, ['access_token'])
  const AccessToken = access_token
  API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
  try {
    const response: ApiResponse = yield APIGetRequest(url, API_PMS_HEADERS)
    
    if (response.status === 200) {
      const dataSourceResponse = response.data
      yield put(actionCreators.rateApproveViewSummaryDataSource(dataSourceResponse))
      yield delay(100)
    } else {
      /* Show error message and signout */
      const { message } = response.data
      const processStatus = { status: false, action: "rateApproveViewSummary", message }
      yield put(actionCreators.rateApproveProcessSuccess(processStatus))
      yield delay(100)
      yield put(actionCreators.rateApproveProcessReset())
      yield delay(100)

    }
  } catch (error) {
    const processStatus = { status: false, action: "rateApproveViewSummary", message: error }
    yield put(actionCreators.rateApproveProcessSuccess(processStatus))
    yield delay(100)
    yield put(actionCreators.rateApproveProcessReset())
    yield delay(100)
  }
}

/* Watcher Saga */
export function* rateApprovePreview() {
  yield takeLatest(actionTypes.RATE_APPROVE_PREVIEW, rateApprovePreviewProcess)
}
export function* rateApproveUpdate() {
  yield takeEvery(actionTypes.RATE_APPROVE_UPDATE, rateApproveUpdateProcess)
}
export function* rateApproveUpdateAll() {
  yield takeEvery(actionTypes.RATE_APPROVE_UPDATE_ALL, rateApproveUpdateAllProcess)
}

export function* rateApproveViewSummary() {
  yield takeEvery(actionTypes.RATE_APPROVE_VIEW_SUMMARY, rateApproveViewSummaryProcess)
}

export default function* rootSaga() {
  yield all([fork(rateApprovePreview),
  fork(rateApproveUpdate),
  fork(rateApproveUpdateAll),
  fork(rateApproveViewSummary)
  ])


}
